import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { Salon } from '../../model';
import { RetailsTestID } from '../../test-ids';
import { FieldLabel } from '../Retails.styles';
import { useRetailsContext } from '../RetailsContext';
import { SalonItem } from './SalonItem';
import { SalonListContainer, SalonListWrapper } from './SalonList.styles';

export const SalonList: FC = () => {
    const { t } = useTranslations();

    const {
        selectedCity,
        selectedSalon,
        selectSalon,
        startSalonMarkerAnimation,
        stopSalonMarkerAnimation,
        isMobileMapVisible,
        baseProductCode,
    } = useRetailsContext();

    const a11yLabels = {
        'aria-live': 'polite' as const,
        'aria-label': t['retails_map.search.results_label'],
    };

    if (selectedCity && selectedCity.salons.length === 0) {
        return (
            <SalonListWrapper
                {...a11yLabels}
                $isMobileVisible={!isMobileMapVisible}
                data-test={RetailsTestID.SALON_LIST_NOT_FOUND}
            >
                {t['retails_map.salon.not_found']}
            </SalonListWrapper>
        );
    }

    if (!selectedCity || selectedCity.salons.length <= 1 || !!selectedSalon) {
        return null;
    }

    const handleClick = (salon: Salon) => {
        selectSalon(salon);
    };

    const handleMouseEnter = (salon: Salon) => {
        startSalonMarkerAnimation(salon.id);
    };

    const handleMouseLeave = (salon: Salon) => {
        stopSalonMarkerAnimation(salon.id);
    };

    return (
        <SalonListWrapper {...a11yLabels} $isMobileVisible={!isMobileMapVisible} data-test={RetailsTestID.SALON_LIST}>
            <SalonListContainer>
                <FieldLabel tag="h2" variant="title-100">
                    {baseProductCode ? t['retails_map.salon_list.title'] : t['retails_map.all_salon_list.title']}
                </FieldLabel>
                <div>
                    {selectedCity.salons.map((salon) => (
                        <SalonItem
                            key={salon.id}
                            salon={salon}
                            onClick={() => handleClick(salon)}
                            onMouseEnter={() => handleMouseEnter(salon)}
                            onMouseLeave={() => handleMouseLeave(salon)}
                        />
                    ))}
                </div>
            </SalonListContainer>
        </SalonListWrapper>
    );
};
